var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFD47E",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24L47.5 36L28.5 48V24Z",
    stroke: "#FFD47E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.e21b90dc21d34b74ae83ce4b7a001a7d.svg";
export { ForwardRef as ReactComponent };